import paymentRoutes from '@/router/parts/management/parts/paymentRoutes'
import settingsRoutes from '@/router/parts/management/parts/settingsRoutes'
import facilityRoutes from '@/router/parts/management/parts/facilityRoutes'
import collectionRoutes from '@/router/parts/management/parts/collectionRoutes'
import residentRoutes from '@/router/parts/management/parts/residentRoutes'
import mailingRoutes from '@/router/parts/management/parts/mailingRoutes'
import { EUserPermissions } from '@zunta/configurations'
import todoRoutes from '@/router/parts/management/parts/todoRoutes'

const metaOnlyChainUser = {
  requiresAuth: true,
  onlyChainUser: true
}

export default [
  {
    path: 'management',
    name: 'management',
    component: () => import('../../../views/app/management/Management.vue'),
    children: [
      ...settingsRoutes,
      ...facilityRoutes,
      ...paymentRoutes,
      ...collectionRoutes,
      ...residentRoutes,
      ...mailingRoutes,
      todoRoutes,
      {
        path: 'mailings/:batch/letters/:letter?/:type?',
        name: 'review-letters',
        meta: { ...metaOnlyChainUser, permissions: [EUserPermissions.REVIEW_STATEMENTS] },
        component: () => import('@/views/app/management/review-letters/ReviewLetters.vue')
      }
    ]
  },
  {
    path: '/app/management/mailings/:batch/statements/:statement?/:type?',
    name: 'review-statements',
    meta: { ...metaOnlyChainUser, permissions: [EUserPermissions.REVIEW_STATEMENTS] },
    component: () => import('@/views/app/management/review-statements/ReviewStatements.vue')
  },
  {
    path: '/mirror',
    name: 'mirror',
    meta: { ...metaOnlyChainUser, permissions: [EUserPermissions.VIEW_RESIDENTS] },
    component: () => import('@/views/app/management/Mirror.vue')
  }
]
